import React, { useContext } from "react";
import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import clsx from "clsx";

// Custom.
import Content from "./Content";
import { LayoutProps } from "./global";
import { VoAppContext } from "services/GlobalState";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      minHeight: "100vh",
      marginLeft: 0,
      marginRight: 0,
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      "&$openHelp": {
        transition: theme.transitions.create(["margin", "width"], {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
        [theme.breakpoints.up("lg")]: {
          marginRight: theme.spacing(70),
        },
      },
    },
    openHelp: {},
  })
);

const Layout: React.FC<LayoutProps> = (props) => {
  const { children, className } = props;
  const classes = useStyles();
  const { state } = useContext<any>(VoAppContext);
  return (
    <div
      className={clsx(
        classes.root,
        { [classes.openHelp]: state.openHelp },
        className
      )}
    >
      {/* <Header /> */}
      {/* <Sidebar /> */}
      {/* <React.Suspense fallback={<VoLoader />}>
        <ErrorBoundary> */}
      <Content>{children}</Content>
      {/* </ErrorBoundary>
      </React.Suspense> */}
    </div>
  );
};

export default Layout;
